/* MILO-20260927T0315Z-b78ea6 */
/* You Fly LA: inquiry forms -> lead web app (assets/yfla-leads.js).

   WHAT IT DOES. When a visitor submits one of the site's inquiry forms, this
   ALSO posts one lead to the lead web app (contract: WEBFORM-CONTRACT.md,
   round 2). The Shopify /contact post is not touched: no listener here calls
   preventDefault, stopPropagation or submit, and nothing waits on the reply.

   WHEN IT SENDS. At the moment the browser builds the form's data for sending
   (the "formdata" event). That moment exists only when the submit really goes
   ahead: the form's own script did not cancel it, the page did not block it
   (honeypot, step checks, required fields), or the form's script is sending
   the data itself (new FormData(form) inside its submit handler, or a later
   form.submit() after a spam check). A formdata event is accepted only for a
   form that saw a submit in the last 2 minutes or is inside a form.submit()
   call. A script reading a form that was never submitted sends nothing. But
   for 2 minutes after a submit, even a cancelled one, another script's
   FormData read of that form, while every field is valid, sends a lead.
   Browsers without the formdata event fall back to "a submit that reached
   window without being cancelled".

   ONCE PER REAL SUBMISSION. Skipped when the honeypot is filled, when a field
   is invalid, or when there is no email and no phone. The same form with the
   same email and phone sends once per 60 seconds (memory and sessionStorage),
   so a double click, a requestSubmit re-dispatch or a quick resubmit after the
   page reloads is one lead. The web app has its own five-minute check on top.

   SWITCHES. window.YFLA_LEADS_OFF = true stops it (checked at load and at
   every submit). ?yfla_leads_debug=1 in the page address logs to the console;
   otherwise it is silent. Every handler is wrapped: it never throws into the
   page. ES5, no dependencies. */
(function (w, d) {
  'use strict';

  /* The live lead web app (the same /exec address LA's site posts to). */
  var EXEC_URL = 'https://script.google.com/macros/s/AKfycbwbI3d64y1WHoi4v9dX2N5uhfUhrkd1--e7d2SKpXRiy0ZB8bQDjxe--N6fPEfXGv1_/exec';

  var SCHOOL = 'youfly';
  var SITE = 'youfly.la';
  var DEDUPE_MS = 60 * 1000;
  var SUBMIT_WINDOW_MS = 120 * 1000;
  var MAX_FIELD = 2000;
  /* Never sent, whatever a future map says (the forwarder drops them too). */
  var NEVER = ['quiet', 'when', 'token', 't', 'key', 'deviceToken'];

  /* One entry per form, keyed by the form's HTML id. Field names are the
     form's own contact[...] names, read from the theme. */
  var FORMS = {
    /* /pages/contact, sections/yfla-contact.liquid: call-back form. Native submit, no script. */
    'ctc-contact-form': {
      form: 'youfly-contact',
      full_name: 'contact[name]', email: 'contact[email]', phone: 'contact[phone]',
      message: [['What are you after', 'contact[Enquiry]'], ['', 'contact[body]'], ['Best time to call', 'contact[Best time to call]']]
    },
    /* Every page, snippets/yfla-contact-modal.liquid: contact pop-up. Native submit; its own handler
       cancels the submit when the honeypot yfla_hp is filled. */
    'yfla-cm-form': {
      form: 'youfly-consult', honeypot: ['yfla_hp'],
      full_name: 'contact[Name]', email: 'contact[email]', phone: 'contact[Phone]',
      course: 'contact[Course]', timeline: 'contact[Start Timeline]',
      message: [['', 'contact[body]']]
    },
    /* Every page, snippets/yfla-enroll-modal.liquid + assets/yfla-book.js: enrollment pop-up. Native submit. */
    'yfla-em-form': {
      form: 'youfly-enroll-modal',
      full_name: 'contact[Full Name]', email: 'contact[email]', phone: 'contact[Phone]',
      course: 'contact[Program]', timeline: 'contact[Timeline]', funding: 'contact[Funding]',
      contact_preference: 'contact[Contact Preference]',
      message: [['Package', 'contact[Package]']]
    },
    /* Homepage, sections/yh-enroll.liquid + assets/yh-home.js: 3-step enrollment form (novalidate).
       Its handler cancels the submit on steps 1-2 and when a required field is empty; the last step
       submits natively. */
    'yfla-enroll': {
      form: 'youfly-enroll',
      first_name: 'contact[First Name]', last_name: 'contact[Last Name]',
      email: 'contact[email]', phone: 'contact[Phone]',
      course: 'contact[Program]', timeline: 'contact[Timeline]', contact_preference: 'contact[Follow Up]',
      message: [['Package', 'contact[Package]'], ['Start date', 'contact[Start Date]']]
    },
    /* /pages/discovery-flights-los-angeles (template page.discovery), sections/yfla-discovery-page.liquid:
       the hero call-back strip and the contact form. Native submit, honeypot contact[Nickname] (not
       blocked on the page, so it is checked here). Not in the original list; see FORM-MAP.md. */
    'dfp-callback': {
      form: 'youfly-discovery-callback', honeypot: ['contact[Nickname]'],
      first_name: 'contact[First name]', email: 'contact[email]', phone: 'contact[Phone]',
      message: [['', 'contact[Request]'], ['Requested from', 'contact[Requested from]']]
    },
    'dfp-contact-form': {
      form: 'youfly-discovery-contact', honeypot: ['contact[Nickname]'],
      full_name: 'contact[Name]', email: 'contact[email]', phone: 'contact[Phone]',
      message: [['', 'contact[body]'], ['Requested from', 'contact[Requested from]']]
    }
  };
  var SIMPLE = ['full_name', 'first_name', 'last_name', 'email', 'phone', 'course', 'timeline', 'funding', 'contact_preference'];

  var DEBUG = false;
  try { DEBUG = /[?&]yfla_leads_debug=1(?:&|#|$)/.test(String(w.location.search) + '#'); } catch (e0) {}
  function log() {
    if (!DEBUG) return;
    try { w.console.log.apply(w.console, ['[yfla-leads]'].concat([].slice.call(arguments))); } catch (e) {}
  }
  function off() { try { return w.YFLA_LEADS_OFF === true; } catch (e) { return false; } }

  try {
    if (w.YFLA_LEADS_LOADED) return;            /* once-guard: a second copy does nothing */
    w.YFLA_LEADS_LOADED = true;
    if (off()) { log('off at load'); return; }
  } catch (e1) { return; }

  function str(v) { return v === null || v === undefined ? '' : String(v).replace(/^\s+|\s+$/g, ''); }
  function now() { return new Date().getTime(); }

  /* The form's tracked config, or null. Only forms posting to /contact count. */
  function cfgOf(f) {
    if (!f || !f.getAttribute) return null;
    var id = f.getAttribute('id') || '';
    if (!FORMS.hasOwnProperty(id)) return null;
    var act = f.getAttribute('action') || '';
    if (act.indexOf('/contact') === -1) return null;
    return FORMS[id];
  }

  /* A field's value by name: the checked one of a radio/checkbox group, else the first enabled one with a value. */
  function val(f, name) {
    var el;
    try { el = f.elements.namedItem(name); } catch (e) { el = null; }
    if (!el) return '';
    var list = (el.tagName ? [el] : el), i, x;
    for (i = 0; i < list.length; i++) {
      x = list[i];
      if (!x || x.disabled) continue;
      if (x.type === 'radio' || x.type === 'checkbox') { if (x.checked) return str(x.value).slice(0, MAX_FIELD); continue; }
      if (str(x.value)) return str(x.value).slice(0, MAX_FIELD);
    }
    return '';
  }

  function honeypotFilled(f, cfg) {
    var names = cfg.honeypot || [], i;
    for (i = 0; i < names.length; i++) if (val(f, names[i])) return true;
    return false;
  }

  /* Side-effect free validity: reads each control's validity without firing "invalid" events. */
  function firstInvalid(f) {
    var els = f.elements, i, x;
    for (i = 0; i < els.length; i++) {
      x = els[i];
      if (x && x.willValidate && x.validity && !x.validity.valid) return x.name || x.id || x.type || 'field';
    }
    return '';
  }

  function build(f, cfg) {
    var b = { action: 'webLead', school: SCHOOL, site: SITE, form: cfg.form, page_source: '' };
    try { b.page_source = String(w.location.href); } catch (e) {}
    var i, k, v, parts = [], m;
    for (i = 0; i < SIMPLE.length; i++) {
      k = SIMPLE[i];
      if (cfg[k]) { v = val(f, cfg[k]); if (v) b[k] = v; }
    }
    m = cfg.message || [];
    for (i = 0; i < m.length; i++) {
      v = val(f, m[i][1]);
      if (v) parts.push(m[i][0] ? m[i][0] + ': ' + v : v);
    }
    if (parts.length) b.message = parts.join('\n').slice(0, MAX_FIELD * 2);
    for (i = 0; i < NEVER.length; i++) delete b[NEVER[i]];
    return b;
  }

  /* 60-second duplicate check: same form, same email and phone. */
  var seen = {};
  var SS_KEY = 'yfla_leads_sent';
  function dupKey(b) {
    return b.form + '|' + str(b.email).toLowerCase() + '|' + str(b.phone).replace(/\D+/g, '');
  }
  function recentlySent(key) {
    var t = now(), store = {};
    if (seen[key] && t - seen[key] < DEDUPE_MS) return true;
    try { store = JSON.parse(w.sessionStorage.getItem(SS_KEY) || '{}') || {}; } catch (e) { store = {}; }
    return !!(store[key] && t - store[key] < DEDUPE_MS && store[key] <= t);
  }
  function markSent(key) {
    var t = now(), store = {}, k;
    seen[key] = t;
    try {
      store = JSON.parse(w.sessionStorage.getItem(SS_KEY) || '{}') || {};
      for (k in store) if (store.hasOwnProperty(k) && !(t - store[k] < DEDUPE_MS)) delete store[k];
      store[key] = t;
      w.sessionStorage.setItem(SS_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  /* POST once, as a simple request (no preflight). Fire and forget. */
  function post(json) {
    var n = w.navigator, ok = false;
    try {
      if (n && typeof n.sendBeacon === 'function' && typeof w.Blob === 'function') {
        ok = n.sendBeacon(EXEC_URL, new w.Blob([json], { type: 'text/plain;charset=utf-8' }));
      }
    } catch (e) { ok = false; }
    if (ok) return 'beacon';
    try {
      if (typeof w.fetch === 'function') {
        var p = w.fetch(EXEC_URL, { method: 'POST', body: json, keepalive: true, mode: 'no-cors', credentials: 'omit' });
        if (p && typeof p['catch'] === 'function') p['catch'](function () {});
        return 'fetch';
      }
    } catch (e2) {}
    return 'none';
  }

  function consider(f, why) {
    if (off()) { log('off, skipped', why); return; }
    var cfg = cfgOf(f);
    if (!cfg) return;
    if (honeypotFilled(f, cfg)) { log('honeypot filled, skipped', cfg.form); return; }
    var bad = firstInvalid(f);
    if (bad) { log('invalid field, skipped', cfg.form, bad); return; }
    var b = build(f, cfg);
    if (!b.email && !b.phone) { log('no email and no phone, skipped', cfg.form); return; }
    var key = dupKey(b);
    if (recentlySent(key)) { log('same submission within 60 s, skipped', cfg.form); return; }
    markSent(key);
    var how = post(JSON.stringify(b));
    log('sent', how, why, b);
  }

  /* ---- signals ---------------------------------------------------------- */
  var HAS_FD = typeof w.FormDataEvent === 'function';
  var lastSubmit = [];                 /* [form, time] pairs, newest last; a few at most */
  var inSubmitCall = null;             /* the form inside a form.submit() call */

  function noteSubmit(f) {
    var t = now(), keep = [], i;
    for (i = 0; i < lastSubmit.length; i++) if (lastSubmit[i][0] !== f && t - lastSubmit[i][1] < SUBMIT_WINDOW_MS) keep.push(lastSubmit[i]);
    keep.push([f, t]);
    lastSubmit = keep.slice(-8);
  }
  function submittedRecently(f) {
    var t = now(), i;
    for (i = 0; i < lastSubmit.length; i++) if (lastSubmit[i][0] === f && t - lastSubmit[i][1] < SUBMIT_WINDOW_MS) return true;
    return false;
  }

  function onSubmitCapture(e) {
    try { var f = e && e.target; if (cfgOf(f)) noteSubmit(f); } catch (x) {}
  }
  function onSubmitBubble(e) {
    try {
      if (HAS_FD) return;              /* formdata decides where it exists */
      var f = e && e.target;
      if (!cfgOf(f) || e.defaultPrevented) return;
      consider(f, 'submit');
    } catch (x) {}
  }
  function onFormData(e) {
    try {
      var f = e && e.target;
      if (!cfgOf(f)) return;
      if (f !== inSubmitCall && !submittedRecently(f)) { log('formdata without a submit, ignored'); return; }
      consider(f, f === inSubmitCall ? 'form.submit()' : 'formdata');
    } catch (x) {}
  }

  try {
    w.addEventListener('submit', onSubmitCapture, true);
    w.addEventListener('submit', onSubmitBubble, false);
    w.addEventListener('formdata', onFormData, true);
  } catch (e2) {}

  /* form.submit() skips the submit event. Mark the call so its formdata counts (a spam check that
     cancels the first submit and submits later this way is still one lead). The original runs
     unchanged, with the same arguments, and its result and errors pass through. */
  try {
    var FP = w.HTMLFormElement && w.HTMLFormElement.prototype;
    var orig = FP && FP.submit;
    if (orig && !orig.__yflaLeads) {
      var wrapped = function () {
        var prev = inSubmitCall, mine = false;
        try { if (cfgOf(this)) { inSubmitCall = this; mine = true; if (!HAS_FD) consider(this, 'form.submit()'); } } catch (x) {}
        try { return orig.apply(this, arguments); }
        finally { if (mine) inSubmitCall = prev; }
      };
      wrapped.__yflaLeads = true;
      FP.submit = wrapped;
    }
  } catch (e3) {}

  log('ready', HAS_FD ? 'formdata' : 'submit fallback');
})(window, document);
